module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTopBtn),
      expression: "showTopBtn"
    }],
    staticClass: "go-back",
    on: {
      "click": _vm.goBackTop
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-54f45ba7!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/goback.vue
// module id = xiOA
// module chunks = 15